import { Link } from 'react-router-dom';

export default function Footer() {
	return (
		<div className="bg-black text-gray-300 py-12 px-4">
			{/* Footer Section */}
			<div className="py-8 bg-black text-white text-center relative overflow-hidden">
				{/* Background Effect */}
			</div>
			<div className="container mx-auto px-10">
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
					{/* Useful Links Section */}
					<div className="space-y-4">
						<h2 className="text-lg font-bold text-[#ffcc00]">
							Useful Links
						</h2>

						<Link
							to="/terms-conditions"
							className="block text-white hover:text-yellow-300"
						>
							Terms & Conditions
						</Link>
						<Link
							to="/privacy-policy"
							className="block text-white hover:text-yellow-300"
						>
							Privacy Policy
						</Link>
						<a
							href="/blog"
							className="block text-white hover:text-yellow-300"
						>
							Blog
						</a>
						<Link
							to="/faqs"
							className="block text-white hover:text-yellow-300"
						>
							FAQs
						</Link>
						<Link
							to="/our-commitment"
							className="block text-white hover:text-yellow-300"
						>
							Our Commitment
						</Link>
					</div>

					{/* Popular Links Section */}
					<div className="space-y-4">
						<h2 className="text-lg font-bold text-[#ffcc00]">
							Our Products
						</h2>
						<a
							href="/our-products/staples"
							className="block text-white hover:text-yellow-300"
						>
							Staples
						</a>
						<a
							href="/our-products/dals-pulses"
							className="block text-white hover:text-yellow-300"
						>
							Dals & Pulses
						</a>
						<a
							href="/our-products/dry-fruits"
							className="block text-white hover:text-yellow-300"
						>
							Nuts & Dry Fruits
						</a>
						<a
							href="/our-products/whole-spices"
							className="block text-white hover:text-yellow-300"
						>
							Whole Spices
						</a>
						<a
							href="/our-products/seeds"
							className="block text-white hover:text-yellow-300"
						>
							Seeds
						</a>
					</div>

					{/* Contact Us Section */}
					<div className="space-y-4">
						<h2 className="text-lg font-bold text-[#ffcc00]">
							Contact Us
						</h2>
						<a
							href=""
							target="_blank"
							rel="noopener noreferrer"
							className="block text-white hover:text-yellow-300"
						>
							<p>
								<i className="fas fa-map-marker-alt mr-2"></i>
								No.490, First Floor, Sri Venkateswara Manor, 80 Feet Road, HMT Layout, RT Nagar, Bangalore-560032.
							</p>
						</a>
						<a
							href="tel:+918838781817"
							className="block text-white hover:text-yellow-300"
						>
							<p>
								<i className="fas fa-phone mr-2"></i>+91
								8838781817
							</p>
						</a>
						<a
							href="mailto:info@vajjiramagro.com"
							className="block text-white hover:text-yellow-300"
						>
							<p>
								<i className="fas fa-envelope mr-2"></i>
								info@vajjiramagro.com
							</p>
						</a>
						<div className="flex space-x-4 mt-4">
							<a
								href="https://www.facebook.com/profile.php?id=61573384433125"
								className="text-white hover:text-yellow-300"
							>
								<i className="fab fa-facebook-f"></i>
							</a>
							<a
								href="https://www.instagram.com/vajjiramagro"
								className="text-white hover:text-yellow-300"
							>
								<i className="fab fa-instagram"></i>
							</a>

							<a
								href="https://www.linkedin.com/company/vajjiram"
								className="text-white hover:text-yellow-300"
							>
								<i className="fab fa-linkedin-in"></i>
							</a>
						</div>
					</div>

					{/* Newsletter Section */}
					<div className="space-y-4">
						<h2 className="text-lg font-bold text-[#ffcc00]">
							Find Us
						</h2>
						<iframe
							src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d485.8973955368937!2d77.593423!3d13.02426!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17b08b230dab%3A0x704529a15b017e72!2sKarunadu%20Products%20India%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1738225990188!5m2!1sen!2sin"
							className="rounded-xl"
							allowFullScreen=""
							loading="lazy"
							referrerPolicy="no-referrer-when-downgrade"
							title="location-map"
						></iframe>
					</div>
				</div>

				{/* Copyright Section */}
				<div className="border-t border-gray-600 mt-8 pt-4">
					<div className="">
						<div className="text-sm text-white text-center">
							&copy;{' '}
							<a
								href="https://www.adfluxagency.com"
								className="text-white hover:text-yellow-300"
							>
								{' '}
								Adflux Agency
							</a>{' '}
							| 2025, All Rights Reserved.
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
